/**
 * Created by valerasiestov on 19.11.15.
 */


if (!window.module) {
    window.module = {};
}

module.order = (function (global) {
    "use strict";

    var controls = {},
        handlers = {
            orderButtonClick: function (event) {
                module.popup.show({
                    url: this.getAttribute('data-url'),
                    transitionElement: '.popup__window',
                    beforeShow: function () {
                        var classList = document.body.classList;
                        classList.add('popup-callback-visible');
                        classList.add('popup-scroll-fix');
                    },
                    afterClose: function () {
                        document.body.classList.remove('popup-scroll-fix');
                    },
                    handlers: {
                        popupClose: function (event) {
                            event.preventDefault();
                            document.body.classList.remove('popup-callback-visible');
                            this.hide().then(function () {
                                module.selection.destroy();
                            });
                        },
                        popupWindowClick: function (event) {
                            event.stopPropagation();
                        }
                    }
                }).then(function (param) {
                    param.dom.querySelector('input[type="text"]').focus();
                });
            }
        };

    function setEventList() {
        global.addEvents(controls.orderButtons, 'click', handlers.orderButtonClick);
        global.addEvents(controls.orderCellButtons, 'click', handlers.orderButtonClick);
        global.addEvents(controls.orderButtonAttr, 'click', handlers.orderButtonClick);
    }

    function getControls() {
        controls.orderButtons = document.querySelectorAll('.table-button-cart');
        controls.orderCellButtons = document.querySelectorAll('.offer__tablet-cell .button');
        controls.orderButtonAttr = document.querySelectorAll('[data-order]');
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}(DALGAKIRAN.global));

window.addEventListener('DOMContentLoaded', function () {

    module.order.init({

    });

}, false);
